import { action, makeObservable, observable, toJS } from 'mobx';
export interface WithId {
   id: string | number;
}

export class MultiSelectViewModel<TValue extends WithId = WithId> {
   opened = false;
   readonly values = observable.array<TValue>([], { deep: true });
   maxSelected: number;
   search: string = '';
   readonly getLabel: (value: TValue) => string;
   onValueChange?: (values: TValue[]) => void;
   constructor(
      values: TValue[] = [],
      options: {
         maxSelected?: number;
         getLabel?: (value: TValue) => string;
         onValueChange?: (values: TValue[]) => void;
      }
   ) {
      makeObservable(this, {
         opened: observable,
         search: observable,
         onOpenedChange: action.bound,
         onSelect: action.bound,
         deselect: action.bound,
         onSearch: action.bound,
         clearSearch: action.bound,
         clear: action.bound,
      });

      this.values.replace(values);
      this.maxSelected = options?.maxSelected ?? 10;
      this.getLabel = options?.getLabel ?? ((v) => String((v as any).label ?? v.id));
      this.onValueChange = options?.onValueChange;
   }

   onOpenedChange(o: boolean): void {
      this.opened = o;
   }

   onSelect(item: TValue): void {
      if (!this.values.find((v) => v.id === item.id) && this.values.length < this.maxSelected) {
         this.values.push(item);
         this.onValueChange?.(toJS(this.values));
         this.emitChanges();
      }
   }

   deselect(item: TValue) {
      const index = this.values.findIndex((v) => v.id === item.id);
      if (index >= 0) {
         this.values.splice(index, 1);
         this.emitChanges();
      }
   }

   onSearch(value: string): void {
      this.search = value;
   }

   clear(): void {
      this.values.clear();
   }

   clearSearch(): void {
      this.search = '';
   }

   private emitChanges(): void {
      this.onValueChange?.(toJS(this.values));
   }
}
